import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'users',
            name: 'user',
            class: 'App\\Models\\User'
        }
    },

    methods: {
        allWithHasAnyPermission(permissions) {
            return this.loadAll({
                scopes: {
                    permission: permissions,
                    with: 'permissions'
                }
            })
        }
    }
}